import { TooltipDirective } from '../../../auxiliares/tooltip/tooltip.directive';
import { BOTONES } from '../../../componentes/botones';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  IUpdateDispositivoAlarma,
  IDispositivoAlarma,
  IActivo,
  IUpdateActivo,
} from 'modelos/src';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import {
  OwlDateTimeModule,
  OwlNativeDateTimeModule,
} from '@danielmoncada/angular-datetime-picker';
import { CardHeaderComponent } from '../../../componentes/card-header/card-header.component';
import { InfoBannerComponent } from '../../../componentes/info-banner/info-banner.component';
import { ContentCardComponent } from '../../../componentes/content-card/content-card.component';
import { UploadFileComponent } from '../../../auxiliares/upload-file/upload-file.component';
import { LoginService } from '../../login/login.service';
import { HelperService } from '../../../auxiliares/servicios/helper.service';
import { AlarmasDomiciliariasService } from '../../entidades/alarmas/alarmas-domiciliarias/alarmas-domiciliarias.service';
import { ParamsService } from '../../../auxiliares/servicios/params.service';
import { ThemesService } from '../../../auxiliares/servicios/themes.service';
import { ActivosService } from '../../../auxiliares/servicios/http/activos.service';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-dar-alta-entidad',
  templateUrl: './dar-alta-entidad.component.html',
  styleUrl: './dar-alta-entidad.component.scss',
  standalone: true,
  imports: [TooltipDirective, 
    CommonModule,
    FormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    BOTONES,
    MatIconModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    CardHeaderComponent,
    InfoBannerComponent,
    ContentCardComponent,
    UploadFileComponent,
  ],
})
export class DarAltaEntidadComponent implements OnInit {
  data = inject<{
    alarma?: IDispositivoAlarma;
    vehiculo?: IActivo;
  }>(MAT_DIALOG_DATA);
  helper = inject(HelperService);
  private alarmasDomiciliariasService = inject(AlarmasDomiciliariasService);
  private activosService = inject(ActivosService);
  dialogRef = inject<MatDialogRef<DarAltaEntidadComponent>>(MatDialogRef);
  paramsService = inject(ParamsService);
  themesService = inject(ThemesService);

  public loading = false;
  public clientePropio = LoginService.getCliente();
  public selectedFechaAlta: string; // Variable temporal para almacenar la fecha seleccionada
  public fechaAlta: string;
  public maxDate: Date = new Date();
  public title?: string;
  public nombreEntidad?: string;
  public urlImagenes: string[] = [];

  ///////////////////////////////////////////////////////////////////////////////////

  public async onSubmit() {
    this.loading = true;
    try {
      let res;
      if (this.selectedFechaAlta) {
        //Si tiene fecha selected es porque se está queriendo dar de alta
        // Dar de alta
        const data = this.getDataAlta();
        if (this.data.alarma) {
          const id = this.data.alarma._id;
          res = await this.alarmasDomiciliariasService.darDeAlta(id, data);
        } else if (this.data.vehiculo) {
          const id = this.data.vehiculo._id;
          res = await this.activosService.update(id, data);
        }
        this.helper.notifSuccess('Dado de alta correctamente');
      } else {
        // Actualizar imágenes
        const data = this.getDataActualizar();
        if (this.data.alarma) {
          const id = this.data.alarma._id;
          res = await this.alarmasDomiciliariasService.update(id, data);
        } else if (this.data.vehiculo) {
          const id = this.data.vehiculo._id;
          res = await this.activosService.update(id, data);
        }
        this.helper.notifSuccess('Imágenes actualizadas correctamente');
      }
      this.dialogRef.close(res);
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
    this.loading = false;
  }

  public getDataAlta(): IUpdateDispositivoAlarma | IUpdateActivo {
    const data: IUpdateDispositivoAlarma = {
      imagenes: this.urlImagenes,
      fechaAlta: this.selectedFechaAlta,
    };
    return data;
  }

  public getDataActualizar(): IUpdateDispositivoAlarma | IUpdateActivo {
    const data = {
      imagenes: this.urlImagenes,
    };
    return data;
  }

  /////////////////////////////////////////////////////////////////////////////
  //HOOKS

  ngOnInit() {
    // Alarma
    if (this.data.alarma) {
      this.nombreEntidad = this.data.alarma.nombre;
      // Alta
      if (!this.data.alarma.fechaAlta) {
        this.title = 'Alta de alarma';
        this.fechaAlta = null;
        this.urlImagenes = this.data.alarma.imagenes;
        this.selectedFechaAlta = new Date().toISOString();
      }
      // Cambio imagenes
      else {
        this.title = 'Actualizar imágenes de alarma';
        this.fechaAlta = this.data.alarma.fechaAlta;
        this.urlImagenes = this.data.alarma.imagenes;
      }
    }

    // Vehículo
    if (this.data.vehiculo) {
      this.nombreEntidad = this.data.vehiculo.identificacion;
      // Alta
      if (!this.data.vehiculo.fechaAlta) {
        this.title = 'Alta de vehículo';
        this.fechaAlta = null;
        this.urlImagenes = this.data.vehiculo.imagenes;
        this.selectedFechaAlta = new Date().toISOString();
      }
      // Cambio imagenes
      else {
        this.title = 'Actualizar imágenes de vehículo';
        this.fechaAlta = this.data.vehiculo.fechaAlta;
        this.urlImagenes = this.data.vehiculo.imagenes;
      }
    }
  }
}
